import React, { memo, useCallback, useState } from "react";
import isEqual from "react-fast-compare";
import {
  IconButton,
  ListItemIcon,
  MenuItem,
  Paper,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  AccountCircle,
  AccountCircleRounded,
  ExitToApp,
} from "@mui/icons-material";
import GlobalSharedStateClass from "../../../util/globalSharedStateClass";
import { LOGIN_PAGE } from "../../../util/constants";

const AccountHeaderPopup = () => {
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const Cache = new GlobalSharedStateClass();

  const onSetAnchor = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(e.currentTarget),
    []
  );

  const onClose = useCallback(() => setAnchorEl(null), []);

  const onLogout = useCallback(() => {
    const GlobalCache = new GlobalSharedStateClass();
    onClose();
    GlobalCache.deleteCachedVouchers();
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    document.location.pathname = LOGIN_PAGE;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Tooltip title={"Account"}>
        <IconButton onClick={onSetAnchor}>
          <AccountCircle color={"secondary"} />
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={Boolean(anchorEl)}
        onClose={onClose}
      >
        <Paper>
          <MenuItem disabled={true}>
            <ListItemIcon>
              <AccountCircleRounded fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">{Cache.getUser()}</Typography>
          </MenuItem>
          <MenuItem onClick={onLogout}>
            <ListItemIcon>
              <ExitToApp fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">Sign out</Typography>
          </MenuItem>
        </Paper>
      </Popover>
    </>
  );
};

export default memo(AccountHeaderPopup, isEqual);
